export default __webpack_public_path__ + "static/media/alethio4.86bc46da.png";